export default "__VITE_ASSET__e571d2ec__"